import type { paths } from '@luxuryescapes/contract-svc-lux-loyalty'
import mapLoyaltyAccountActivity from 'api/mappers/loyalty/mapLoyaltyAccountActivity'
import requestUtils from 'api/requestUtils'
import qs from 'qs'

type Response = paths['/api/lux-loyalty/account/activities']['get']['responses']['200']['content']['application/json']

async function requestLoyaltyAccountActivity(customerId: string, startDate: string, endDate: string, page: number = 1) {
  const params = qs.stringify({
    customerId,
    fromDate: startDate,
    toDate: endDate,
    page,
  })
  const response = await requestUtils.get<Response>(`/api/lux-loyalty/account/activities?${params}`, {
    credentials: 'include',
    excludeBrand: true,
  })

  return {
    activities: response.result.activities.map(mapLoyaltyAccountActivity),
    hasNextPage: response.result.pageInfo.hasNextPage,
  }
}

export default requestLoyaltyAccountActivity
